import { render, staticRenderFns } from "./priceListTable.vue?vue&type=template&id=262050a0&"
import script from "./priceListTable.vue?vue&type=script&lang=ts&"
export * from "./priceListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports